export const ALLOWED_FILE_TYPES = {
    IMAGE: {
      'image/jpeg': { ext: '.jpg', maxSize: 5 * 1024 * 1024 },
      'image/png': { ext: '.png', maxSize: 5 * 1024 * 1024 },
      'image/webp': { ext: '.webp', maxSize: 5 * 1024 * 1024 },
    },
    AUDIO: {
      'audio/aac': { ext: '.aac', maxSize: 16 * 1024 * 1024 },
      'audio/mp4': { ext: '.m4a', maxSize: 16 * 1024 * 1024 },
      'audio/mpeg': { ext: '.mp3', maxSize: 16 * 1024 * 1024 },
      'audio/amr': { ext: '.amr', maxSize: 16 * 1024 * 1024 },
      'audio/ogg': { ext: '.ogg', maxSize: 16 * 1024 * 1024 },
      'audio/opus': { ext: '.opus', maxSize: 16 * 1024 * 1024 },
    },
    VIDEO: {
      'video/mp4': { ext: '.mp4', maxSize: 16 * 1024 * 1024 },
      'video/3gpp': { ext: '.3gp', maxSize: 16 * 1024 * 1024 },
    },
    DOCUMENT: {
      'text/plain': { ext: '.txt', maxSize: 100 * 1024 * 1024 },
      'application/pdf': { ext: '.pdf', maxSize: 100 * 1024 * 1024 },
      'application/msword': { ext: '.doc', maxSize: 100 * 1024 * 1024 },
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': { ext: '.docx', maxSize: 100 * 1024 * 1024 },
      'application/vnd.ms-powerpoint': { ext: '.ppt', maxSize: 100 * 1024 * 1024 },
      'application/vnd.openxmlformats-officedocument.presentationml.presentation': { ext: '.pptx', maxSize: 100 * 1024 * 1024 },
      'application/vnd.ms-excel': { ext: '.xls', maxSize: 100 * 1024 * 1024 },
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': { ext: '.xlsx', maxSize: 100 * 1024 * 1024 },
    }
  };
  
  const getAllowedTypes = () => {
    return {
      ...ALLOWED_FILE_TYPES.IMAGE,
      ...ALLOWED_FILE_TYPES.AUDIO,
      ...ALLOWED_FILE_TYPES.VIDEO,
      ...ALLOWED_FILE_TYPES.DOCUMENT,
    };
  };
  
  export const validateFile = (file) => {
    const allowedTypes = getAllowedTypes();
    const fileType = allowedTypes[file.type];
    
    if (!fileType) {
      return { isValid: false, error: "File type not supported" };
    }
    
    if (file.size > fileType.maxSize) {
      return { isValid: false, error: `File size exceeds 16MB limit. Current size: ${(file.size / (1024 * 1024)).toFixed(2)}MB` };
    }
    
    return { isValid: true };
  };